import ProfilePage from './ProfilePage/ProfilePage';
import RedirectMyProfileToProfilePage from './ProfilePage/RedirectMyProfileToProfilePage/RedirectMyProfileToProfilePage';
import RedirectToPage from './RedirectToPage';
import NotFound from './NotFound';
import Explore from './Explore/Explore';
import {
  ARENA_EXPLORE_URL,
  ARENA_HOW_IT_WORKS_URL,
  ARENA_GET_HIRED_URL,
  ARENA_SMALL_TASKS_URL,
  ARENA_PROFILE_PAGE_URL,
  ARENA_OLD_PROFILE_PAGE_URL,
  ARENA_MY_PROFILE_URL,
} from '../utils/constants';

const Routes = [
  {
    path: '/',
    exact: true,
    component: RedirectToPage,
  },
  {
    path: ARENA_SMALL_TASKS_URL,
    component: RedirectToPage,
  },
  {
    path: ARENA_HOW_IT_WORKS_URL,
    component: RedirectToPage,
  },
  {
    path: ARENA_GET_HIRED_URL,
    component: RedirectToPage,
  },
  {
    path: ARENA_MY_PROFILE_URL,
    component: RedirectMyProfileToProfilePage,
  },
  {
    path: `${ARENA_PROFILE_PAGE_URL}/:userName`,
    component: ProfilePage,
  },
  {
    path: `${ARENA_OLD_PROFILE_PAGE_URL}/:userName`,
    component: ProfilePage,
  },
  {
    path: `${ARENA_EXPLORE_URL}/:mainCategoryDisplayKey?/:mainServiceDisplayKey?`,
    component: Explore,
  },
  {
    path: '*',
    component: NotFound,
  },
];

export default Routes;
